module.exports = __webpack_public_path__ + "static/img/15022C_1_C_20210323_LC.3cc6270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15022C_1_C_20210323_LC.png
// module id = +Ap/
// module chunks = 0